import 'react-slidedown/lib/slidedown.css';

import * as React from 'react';
import classnames from 'classnames';
import Calendar from '../Calendar';
const SlideDown = require('react-slidedown').SlideDown;

interface Props {
    onSectionExpanded?: () => void;
    calendarRef?: React.Ref<HTMLDivElement>;
    availability: { [date: string]: number } | null;
    lastUpdatedDate?: string;
    isShown: boolean;
}

export interface State {
    isShown: boolean;
}

export default class ServiceOptions extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isShown: props.isShown,
        };
        this.handleToggleClick = this.handleToggleClick.bind(this);
    }

    public render() {
        const { availability } = this.props;

        return (
            <div
                className={classnames('VenuePage--detail', 'VenuePage--detail__expandable', 'VenuePage--no-border', {
                    'VenuePage--detail__expanded': this.state.isShown,
                })}
            >
                <div className='VenuePage--detail-headline-container' onClick={this.handleToggleClick} ref={this.props.calendarRef}>
                    <h3 className='VenuePage--detail-headline VenuePage--detail-headline__expandable' onClick={this.handleToggleClick}>
                        Availability
                        <i
                            className={classnames('icon-hb-nx-arrow-down-16', { 'icon-hb-nx-arrow-down-16__flipped': this.state.isShown })}
                        />
                    </h3>
                </div>

                <div className='VenuePage--additional-detail-container'>
                    <SlideDown className={'VenuePage--row'}>
                        {this.state.isShown && (
                            <div className='VenuePage--additional-detail '>
                                <div className='VenuePage--calendar-key'>
                                    <span className='VenuePage--calendar-key-item'>
                                        <div className='VenuePage--calendar-key-box VenueProfile--calendar-date-pink' />
                                        <span className='VenuePage--calendar-key-label'>Partially Reserved</span>
                                    </span>
                                    <span className='VenuePage--calendar-key-item'>
                                        <div className='VenuePage--calendar-key-box VenueProfile--calendar-date-blue' />
                                        <span className='VenuePage--calendar-key-label'>Daytime Only Available</span>
                                    </span>
                                    <span className='VenuePage--calendar-key-item'>
                                        <div className='VenuePage--calendar-key-box VenueProfile--calendar-date-black' />
                                        <span className='VenuePage--calendar-key-label'>Reserved</span>
                                    </span>
                                </div>
                                <Calendar
                                    yearsRange={[2017, 2018, 2019]}
                                    minDate={[]}
                                    getDateClassname={(date) => {
                                        if (availability === null) {
                                            return '';
                                        }
                                        const status = availability[date];
                                        switch (status) {
                                            case 0:
                                                return '';
                                            case 1:
                                                return 'VenueProfile--calendar-date-black';
                                            case 2:
                                                return 'VenueProfile--calendar-date-pink';
                                            case 4:
                                                return 'VenueProfile--calendar-date-blue';
                                            default:
                                                return '';
                                        }
                                    }}
                                />
                                {this.props.lastUpdatedDate && (
                                    <div className='VenuePage--calendar-footer'>Last updated {this.props.lastUpdatedDate}</div>
                                )}
                            </div>
                        )}
                    </SlideDown>
                </div>
            </div>
        );
    }

    private handleToggleClick(e: React.SyntheticEvent<HTMLElement>) {
        const trigger = !this.state.isShown;
        this.setState({ isShown: !this.state.isShown });
        if (trigger) {
            this.props.onSectionExpanded && this.props.onSectionExpanded();
        }
    }
}
